module.exports = __webpack_public_path__ + "./Carol_color_2bbc03e295c3c672566b9a34702e89a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Carol_color.jpg
// module id = 588
// module chunks = 0